module.exports = __webpack_public_path__ + "static/media/service3.c56fbc2b.jpeg";